const CPF_LENGTH = 11;
const CNPJ_LENGTH = 14;

export function maskCNPJ(value: string): string {
  const digits = value.replace(/\D/g, "");
  let masked = "";
  if (digits.length > 0) masked += digits.substring(0, 2);
  if (digits.length > 2) masked += "." + digits.substring(2, 5);
  if (digits.length > 5) masked += "." + digits.substring(5, 8);
  if (digits.length > 8) masked += "/" + digits.substring(8, 12);
  if (digits.length > 12) masked += "-" + digits.substring(12, 14);
  return masked;
}

export function maskCPF(value: string): string {
  const digits = value.replace(/\D/g, "");
  let masked = "";
  if (digits.length > 0) masked += digits.substring(0, 3);
  if (digits.length > 3) masked += "." + digits.substring(3, 6);
  if (digits.length > 6) masked += "." + digits.substring(6, 9);
  if (digits.length > 9) masked += "-" + digits.substring(9, 11);
  return masked;
}

const documentMasks: Record<number, (value: string) => string> = {
  [CPF_LENGTH]: maskCPF,
  [CNPJ_LENGTH]: maskCNPJ,
};

export function formatDocument(value?: string | null): string {
  const trimmed = value?.trim();
  if (!trimmed) return "-";
  const mask = documentMasks[trimmed.replace(/\D/g, "").length];
  return mask ? mask(trimmed) : trimmed;
}
